export const INITIALIZE_ASSIGNMENTS = 'INITIALIZE_ASSIGNMENTS'
export const UPDATE_ASSIGNMENTS_LIST = 'UPDATE_ASSIGNMENTS_LIST'
export const APPLY_ASSIGNMENT_FILTERS = 'APPLY_ASSIGNMENT_FILTERS'
export const SET_IS_FETCHING_ASSIGNMENTS = 'SET_IS_FETCHING_ASSIGNMENTS'

export const GET_NEWSLETTERS = 'GET_NEWSLETTERS'
